import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import { ChevronLeft, ChevronRight, LucideIcon } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@ui/CarouselV1";

interface Props {
  items: React.ReactNode[];
  className?: string;
  itemClassName?: string;
  options?: EmblaOptionsType;
  plugins?: any;
  orientation?: "vertical" | "horizontal";
  prevIcon?: LucideIcon;
  nextIcon?: LucideIcon;
  navigationStyle?: string;
  app?: "b2c" | "b2b"; //remove this prop
}

const ContentCarousel = ({
  items,
  options,
  plugins,
  orientation = "horizontal",
  className,
  itemClassName = "md:basis-1/3 lg:basis-1/5",
  prevIcon = ChevronLeft,
  nextIcon = ChevronRight,
  navigationStyle,
}: Props) => {
  return (
    <Carousel
      className={`w-full ${className}`}
      opts={options}
      plugins={plugins}
      orientation={orientation}
    >
      {
        <CarouselContent>
          {items?.map((item, index) => (
            <CarouselItem key={index} className={itemClassName}>
              {item}
            </CarouselItem>
          ))}
        </CarouselContent>
      }
      <CarouselPrevious
        className={`top-[100px] border-black bg-black text-white hover:border-white hover:text-white dark:bg-white dark:text-black dark:hover:text-black ${navigationStyle}`}
        dir={options?.direction}
        Icon={prevIcon}
      />
      <CarouselNext
        className={`top-[100px] border-white bg-black text-white hover:text-white dark:border-black dark:bg-white dark:text-black dark:hover:text-white ${navigationStyle}`}
        dir={options?.direction}
        Icon={nextIcon}
      />
    </Carousel>
  );
};

export default ContentCarousel;
